import {combineReducers, configureStore} from "@reduxjs/toolkit";
import storage from 'redux-persist/lib/storage';
import common from './common';
import exhibition from "./exhibition";
import commentator from "./commentator";
import {persistReducer} from "redux-persist";
import audio from "./audio";
import account from "./account";

const reducers = combineReducers({
    commonData: common.reducer,
    exhibitionData: exhibition.reducer,
    commentatorData: commentator.reducer,
    audioData: audio.reducer,
    accountData: account.reducer,
})
const persistConfig = {
    key: 'root',
    storage,
}
const persistedReducer = persistReducer(persistConfig, reducers);
const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware =>
            getDefaultMiddleware({serializableCheck: false,})
    ),
})

export default store;